var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperClipSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12312 2.88351C9.58758 1.41904 11.962 1.41904 13.4264 2.88351C14.8909 4.34797 14.8909 6.72234 13.4264 8.18681L10.598 11.0152C9.71931 11.8939 8.29469 11.8939 7.41601 11.0152C6.53733 10.1366 6.53733 8.71193 7.41601 7.83325L10.2444 5.00483C10.5373 4.71193 11.0122 4.71193 11.3051 5.00483C11.598 5.29772 11.598 5.77259 11.3051 6.06549L8.47667 8.89391C8.18378 9.18681 8.18378 9.66168 8.47667 9.95457C8.76957 10.2475 9.24444 10.2475 9.53733 9.95457L12.3658 7.12615C13.2444 6.24747 13.2444 4.82285 12.3658 3.94417C11.4871 3.06549 10.0625 3.06549 9.18378 3.94417L3.54902 9.57892C2.65814 10.4698 2.65814 11.9142 3.54902 12.8051C4.43991 13.696 5.88431 13.696 6.7752 12.8051L7.10665 12.4736C7.39955 12.1807 7.87442 12.1807 8.16731 12.4736C8.46021 12.7665 8.46021 13.2414 8.16731 13.5343L7.83586 13.8658C6.35919 15.3424 3.96503 15.3424 2.48836 13.8658C1.01169 12.3891 1.01169 9.99493 2.48836 8.51826L8.12312 2.88351Z",
    fill: "#C3CBD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipSmall);
export default __webpack_public_path__ + "static/media/paper-clip-small.888a3e761ddde3b5ef4a964699ffd6a5.svg";
export { ForwardRef as ReactComponent };